import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck,
    faTimes,
} from "@fortawesome/pro-regular-svg-icons";

const enabledBadge = (isEnabled) => {
    const statusBGColor = {
        true: "text-secondary-500",
        false: "text-error-500",
    };

    return (
        <div className="flex items-center">
            <FontAwesomeIcon
                icon={isEnabled ? faCheck : faTimes}
                className={`text-xl font-bold ${statusBGColor[isEnabled]}`}
            />
        </div>
    );
};

export default enabledBadge
